import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import { Spin } from "antd";
import asyncComponent from "../../helpers/AsyncFunc";
import { getCurrentUserPermissions, getCurrentUser, getRoles } from "../../helpers/parseHelper";

const routes = [
    {
        path: "",
        component: asyncComponent(() => import("../Home")),
    },
    {
        path: "serverLog",
        component: asyncComponent(() => import("../ServerLog")),
    },
    {
        path: "deposit",
        component: asyncComponent(() => import("../Deposit")),
    },
    {
        path: "settlement",
        component: asyncComponent(() => import("../Settlement")),
    },
    {
        path: "admin",
        component: asyncComponent(() => import("../AdminUser")),
    },
    {
        path: "role",
        component: asyncComponent(() => import("../Role")),
    },
    {
        path: "setting",
        component: asyncComponent(() => import("../GlobalConfig")),
    },
    {
        path: "activity",
        component: asyncComponent(() => import("../Activity")),
    },
    {
        path: "client",
        component: asyncComponent(() => import("../Client")),
    },
    {
        path: "booth",
        component: asyncComponent(() => import("../Booth")),
    },
    {
        path: "frame",
        component: asyncComponent(() => import("../Frame")),
    },
    {
        path: "boothinfo",
        component: asyncComponent(() => import("../Boothinfo")),
    },
    {
        path: "template",
        component: asyncComponent(() => import("../Template")),
    },
    {
        path: "printer",
        component: asyncComponent(() => import("../Printer")),
    },
    {
        path: "monitor",
        component: asyncComponent(() => import("../Monitor")),
    },
    {
        path: "filter",
        component: asyncComponent(() => import("../Filter")),
    },
    {
        path: "computer",
        component: asyncComponent(() => import("../Computer")),
    },
    {
        path: "camera",
        component: asyncComponent(() => import("../Camera")),
    },
    {
        path: "boothanalytics",
        component: asyncComponent(() => import("../BoothAnalytics")),
    },
    {
        path: "member",
        component: asyncComponent(() => import("../Member")),
    },
    {
        path: "redeemcampaign",
        component: asyncComponent(() => import("../RedeemCampaign")),
    },
    {
        // Gated by its own BOOTHCAPTURELOG permission (derived from the path) so
        // roles like owner/manager can monitor booth errors without also being
        // handed the raw Server Logs.
        path: "boothcapturelog",
        component: asyncComponent(() => import("../BoothCaptureLog")),
    },
];

class AppRouter extends Component {
    state = {
        filteredRoutes: null,
        routesLoadError: null,
    };
    componentDidMount = async () => {
        try {
            const currentUser = await getCurrentUser();
            const permissionItems = await getCurrentUserPermissions(currentUser);
            const role = await getRoles(currentUser.get("roleId"));
            const { clientId } = role;

            let mappedPermissions = Object.keys(permissionItems || {})?.filter((item) => permissionItems[item]?.includes("VIEW"));
            mappedPermissions = mappedPermissions.map((k) => k.toUpperCase());
            mappedPermissions.push("");

            // If user is a client (has clientId), always include these routes regardless of permissions
            // Clients are separate from the role/permission system
            if (clientId) {
                const clientRoutes = ["", "BOOTHANALYTICS", "BOOTH", "FILTER", "BOOTHINFO", "TEMPLATE", "FRAME", "SETTLEMENT", "MEMBER", "REDEEMCAMPAIGN"];
                clientRoutes.forEach((route) => {
                    const r = route.toUpperCase();
                    if (!mappedPermissions.includes(r)) {
                        mappedPermissions.push(r);
                    }
                });
            }

            const filteredRoutes = routes.filter((item) =>
                mappedPermissions.includes((item.permissionKey || item.path).toUpperCase())
            );
            this.setState({ filteredRoutes, routesLoadError: null });
        } catch (e) {
            console.error("AppRouter: failed to load routes", e);
            this.setState({ filteredRoutes: [], routesLoadError: e.message || "load failed" });
        }
    };
    render() {
        const { url, style } = this.props;
        const { filteredRoutes, routesLoadError } = this.state;

        if (filteredRoutes === null) {
            return (
                <div style={{ padding: 48, textAlign: "center", ...style }}>
                    <Spin size="large" />
                </div>
            );
        }

        if (routesLoadError) {
            return (
                <div style={{ padding: 24, ...style }}>
                    โหลดสิทธิ์เมนูไม่สำเร็จ: {routesLoadError}
                </div>
            );
        }

        return (
            <div style={style}>
                <Switch>
                    {filteredRoutes.map((singleRoute) => {
                        const { path, exact, ...otherProps } = singleRoute;
                        return (
                            <Route
                                exact={exact === false ? false : true}
                                key={singleRoute.path === "" ? "home" : singleRoute.path}
                                path={`${url}/${singleRoute.path}`}
                                {...otherProps}
                            />
                        );
                    })}
                    <Route
                        render={() => (
                            <div style={{ padding: 24 }}>
                                ไม่พบหน้าที่ต้องการ หรือบัญชีของคุณไม่มีสิทธิ์เข้าถึงเมนูนี้
                            </div>
                        )}
                    />
                </Switch>
            </div>
        );
    }
}

export default AppRouter;
